import React from 'react';
import { createPortal } from 'react-dom';
import { connect } from 'react-redux';
import Spinner from './Spinner';
var LoadingLayer = function (_a) {
    var loading = _a.loading;
    var RenderLoadingLayer = function () {
        if ((loading === null || loading === void 0 ? void 0 : loading.full) && Object.keys(loading.full).length !== 0) {
            return (React.createElement("div", { className: 'fixed flex flex-col h-screen w-screen text-primary justify-center bg-gray-dark items-center' },
                React.createElement(Spinner, null)));
        }
        else {
            return null;
        }
    };
    return createPortal(React.createElement(RenderLoadingLayer, null), document.querySelector('#loading'));
};
var mapStateToProps = function (state) {
    return {
        loading: state.app.loading,
    };
};
export default connect(mapStateToProps)(LoadingLayer);
